export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes';
export const TIMEOUT_SEC = 10;
export const API_KEY = '2c7acfa6-05a5-4051-a7ff-c624fb5ab472';
export const Result_Per_Page = 10;
